import { Wand2, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { POLISH_PRESETS } from "@/lib/soap";

export function PolishMenu({ onPick, disabled }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="rounded-full" disabled={disabled} data-testid="ai-polish-note-button">
          <Wand2 className="h-4 w-4 mr-2 text-amber-600" /> Polish <ChevronDown className="h-3 w-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Improve this note</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {POLISH_PRESETS.map((p) => (
          <DropdownMenuItem key={p.key} onClick={() => onPick(p.key)} data-testid={`polish-preset-${p.key}`}>
            {p.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
